import { memo } from "react";

import classnames from "classnames";
import { joinHyphenCase } from "neetocommons/utils/general";
import { Typography } from "neetoui";
import { omit } from "ramda";
import { withRouter, Link } from "react-router-dom";

import { UNSUPPORTED_LINK_PROPS } from "./constants";
import "./settings.scss";

const Item = ({
  label,
  description,
  icon: Icon = null,
  path,
  href,
  dataTestid,
  className = "",
  children,
  ...otherProps
}) => {
  const commonProps = {
    "data-testid": dataTestid,
    className: classnames(
      "neeto-molecules-settings-link neeto-ui-rounded-lg neeto-ui-border-gray-300 flex cursor-pointer flex-col gap-y-4 border p-6 no-underline outline-none transition-shadow duration-300 ease-in-out group",
      className
    ),
    ...omit(UNSUPPORTED_LINK_PROPS, otherProps),
  };

  const LinkElement = href ? "a" : Link;
  const linkProps = href
    ? { href, ...commonProps }
    : { to: path, ...commonProps };

  return (
    <LinkElement {...linkProps}>
      <div
        className="neeto-molecules-settings-item"
        data-testid={`settings-item-${joinHyphenCase(label)}`}
      >
        <div className="mb-2.5 flex items-center gap-3">
          {Icon && <Icon className="neeto-ui-text-gray-500" size={24} />}
          <Typography
            className="neeto-molecules-settings-item-heading neeto-ui-text-black transition-color text-lg leading-6 duration-300 ease-in-out"
            data-testid="settings-item-heading"
            style="h3"
            weight="semibold"
          >
            {label}
          </Typography>
        </div>
        <Typography
          className="neeto-ui-text-gray-600"
          data-testid="settings-item-description"
          style="body2"
        >
          {description}
        </Typography>
      </div>
      {children && (
        <div className="neeto-ui-border-gray-300 border-t pt-3">{children}</div>
      )}
    </LinkElement>
  );
};

export default memo(withRouter(Item));
